import { render, staticRenderFns } from "./ProductionOrderDetailModal.vue?vue&type=template&id=74717c6f"
import script from "./ProductionOrderDetailModal.vue?vue&type=script&lang=js"
export * from "./ProductionOrderDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports